import http from './httpCommon';

export default {
    sendMail(toEmail: string, subject: string, body: string) {
        http
            .post('/mail', { toEmail: toEmail, subject: subject, body: body })
            .then(response => (console.log(response)))
    }
}